import { Button } from "@/components/ui/button";

interface ActivityItemProps {
  action: string;
  client: string;
  time: string;
  status: "Success" | "Error" | "Rate-limited";
}

export function ActivityItem({
  action,
  client,
  time,
  status,
}: ActivityItemProps) {
  const color =
    status === "Success"
      ? "bg-[#00FF4C]"
      : status === "Error"
        ? "bg-[#FF0000]"
        : "bg-[#F59E0B]";

  return (
    <div className="flex items-center justify-between text-sm">
      <div>
        <p className="text-xs leading-5 font-bold -tracking-wide text-white">
          {action}
        </p>
        <p className="text-black-300 text-xs leading-5 font-medium -tracking-wide">
          {client} • {time}
        </p>
      </div>
      <div className="flex flex-row items-center gap-5">
        <div className="flex items-center gap-1">
          <div className={`${color} mr-1 h-2 w-2 rounded-full`}></div>
          <p className="text-[16px] leading-5 font-bold -tracking-wide text-white">
            {status}
          </p>
        </div>
        <Button
          variant="minimal"
          className="p-1.5 text-xs leading-normal font-bold tracking-normal text-white hover:bg-white/30 hover:text-white"
        >
          Go to client log
        </Button>
      </div>
    </div>
  );
}
